import { ChainId } from '@src/configs/chainInfo'
import { IExchangeData } from '@src/types/exchange'

// EVM Chain Utilities
export const isEVMChain = (chainId: number | string): boolean => {
    const nonEVMChains = [ChainId.Solana, ChainId.Tron, ChainId.Bitcoin]
    return !nonEVMChains.includes(+chainId)
}

// Check if a chain is a Feather chain (direct deposit flow)
export const isFeatherChain = (chainId: number | string): boolean => {
    // Currently only Bitcoin is a Feather chain
    return +chainId === ChainId.Bitcoin
}

export const isOriginEVM = (networkId: number | string): boolean => {
    return isEVMChain(networkId)
}

export const isCrossChainEVMNonEVM = (sellChainId: number | string, buyChainId: number | string): boolean => {
    return isEVMChain(sellChainId) !== isEVMChain(buyChainId)
}

// Solana Chain Utilities
export const isOriginSolana = (networkId: number | string): boolean => {
    return +networkId === ChainId.Solana
}

export const isDestinationSolana = (networkId: number | string): boolean => {
    return +networkId === ChainId.Solana
}

// Tron Chain Utilities
export const isOriginTron = (networkId: number | string): boolean => {
    return +networkId === ChainId.Tron
}

export const isDestinationTron = (networkId: number | string): boolean => {
    return +networkId === ChainId.Tron
}

// Chain Restriction Utilities
export const getDisabledChains = (sellData: IExchangeData) => {
    return [+sellData.chainId]
}
